import * as React from "react";
import { FormGroup } from "../Workflows/RightAside/RightAsideHelpers";
import { PopoverInvitation } from "./types";
import Input from "@/components/Input";
import { IconClose } from "@velaro/velaro-component-lib";
import { TertiaryGrayButton } from "@velaro/velaro-component-lib";
import { IconPlus } from "@velaro/velaro-component-lib";
import { FormValidator } from "@velaro/velaro-component-lib";

interface Props {
  onUpdate(invitation: PopoverInvitation): void;
  invitation: PopoverInvitation;
  errors: Record<string, string>;
}

export default function PopoverInvitationEditor({
  invitation,
  errors,
  onUpdate
}: Props) {
  const messages = Array.isArray(invitation.messages) ? invitation.messages : [""];

  return (
    <>
      <FormGroup
        label="Message delay (seconds)"
        tooltipText="The number of seconds to wait before showing the popover"
      >
        <FormValidator error={errors["messageDelaySeconds"]}>
          <Input
            type="number"
            value={invitation.messageDelaySeconds ?? 3}
            onChange={(value) =>
              onUpdate({
                ...invitation,
                messageDelaySeconds: parseInt(value) || 0
              })
            }
          />
        </FormValidator>
      </FormGroup>
      <FormGroup label="Messages">
        <FormValidator error={errors["messages"]}>
          <div className="flex flex-col gap-2">
            {messages.map((message, index) => (
              <div key={index}>
                <Input
                  value={message}
                  onChange={(value) => {
                    const newMessages = [...messages];
                    newMessages[index] = value;
                    onUpdate({ ...invitation, messages: newMessages });
                  }}
                  suffixIcon={
                    messages.length > 1 ? (
                      <div
                        className="cursor-pointer text-slate-500"
                        onClick={() => {
                          const newMessages = [...messages];
                          newMessages.splice(index, 1);
                          onUpdate({ ...invitation, messages: newMessages });
                        }}
                      >
                        <IconClose />
                      </div>
                    ) : undefined
                  }
                />
              </div>
            ))}
            <TertiaryGrayButton
              label="Add Message"
              prefixIcon={<IconPlus />}
              onClick={() =>
                onUpdate({
                  ...invitation,
                  messages: [...messages, ""]
                })
              }
            />
          </div>
        </FormValidator>
      </FormGroup>
      <FormGroup label="CTA Button Label" tooltipText="Leave empty to hide the button">
        <Input
          value={invitation.ctaLabel ?? ""}
          onChange={(value) => onUpdate({ ...invitation, ctaLabel: value })}
        />
      </FormGroup>
    </>
  );
}
